import { lookupTableReducer, ActionLookupReducer } from 'Modules/core/redux';

import { documentsActions } from './actions';
import { DocsReducer } from './types';


const initialState: DocsReducer = {};

const actionLookup: ActionLookupReducer<DocsReducer> = {
    [`${documentsActions.setLoading}`]: (state, { group, isLoading }) =>
        ({
            ...state,
            [group]: {
                ...state[group],
                isLoading,
            },
        }),
    [`${documentsActions.setError}`]: (state, { group, error }) => ({
        ...state,
        [group]: {
            ...state[group],
            error,
        },
    }),
    [`${documentsActions.setDocs}`]: (state, { group, data }) => ({
        ...state,
        [group]: {
            ...state[group],
            data,
        },
    }),
};

export const reducer = lookupTableReducer(initialState, actionLookup);
